import React from "react";
import "./ScribbleLine.css";
import scribbleline from "../../assets/scribbleLine/bottomline2.svg";

const ScribbleLine = () => {
  return (
    <section className="sectionBorderLine">
      <img src={scribbleline} alt="" className="bottomline" />
    </section>
  );
};

export default ScribbleLine;
